module.exports = __webpack_public_path__ + "assets/img/2.17b18ee6.png";